import React, { Component } from 'react';
import * as classes from './CustomFadeBox.module.scss';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";


class CustomFadeBox extends Component {
    constructor() {
        super();
        this.state = {}
    }

    onRemove = () => {
        const { onRemove, id } = this.props;
        onRemove(id);
    };

    isCustomerStyles = () => {
        if (DataUtil.isFrancetv() && this.props.id === "Vidéo intégrale incrustée") {
            return true;
        }
        return false;
    }

    getShowData = () => {
        if (this.isCustomerStyles()) {
            return this.props.value;
        }
        return DataUtil.sliceShortName(this.props.value, 15);
    }

    getBtnClasses = () => {
        if (this.isCustomerStyles()) {
            return classes.LargeDiv;
        }
        return classes.Div;
    }
    render() {
        let data = this.getShowData();
        return (
            <div className={classes.Box}>
                <div className={this.getBtnClasses()} id={this.props.id} value={this.props.value} onClick={this.onRemove}>{data}</div>
            </div>
        )
    }
}

export default CustomFadeBox;


